import { ROUTE_CONSTANTS } from '@app/core/constants/route.constant';
import { IOnboardingStatus, IOnboardingStepDef } from '../interfaces/onboarding.interface';

/**
 * Getting-started steps, in the order a new coach is meant to work through them. Registering already
 * counts as the first step, so a new coach starts at "1 of 5" (endowed progress effect: a head start
 * makes finishing likelier).
 */
export const ONBOARDING_STEPS: IOnboardingStepDef[] = [
    {
        key: 'accountCreated',
        label: 'onboarding.steps.account',
        route: ['/', ROUTE_CONSTANTS.USER.ROOT, ROUTE_CONSTANTS.USER.ACCOUNT],
    },
    { key: 'sessionCreated', label: 'onboarding.steps.session', route: ['/', ROUTE_CONSTANTS.HOME] },
    { key: 'playerAdded', label: 'onboarding.steps.player', route: ['/', ROUTE_CONSTANTS.SQUAD] },
    { key: 'historyViewed', label: 'onboarding.steps.history', route: ['/', ROUTE_CONSTANTS.SESSIONS] },
    { key: 'calendarEventCreated', label: 'onboarding.steps.calendar', route: ['/', ROUTE_CONSTANTS.CALENDAR] },
];

export function isOnboardingStepDone(status: IOnboardingStatus | null, step: IOnboardingStepDef): boolean {
    return step.key === 'accountCreated' || !!status?.steps[step.key];
}
